import { Button } from '@/components/Common';
import { TextEditor } from '@/components/Ui';
import { useSummary } from './summary.hook';
import { AiLoader } from '@/components/Ui/AiLoader/AiLoader';
import summaryIcon from '@/assets/icons/resume.svg';
export const Summary = () => {
  const {
    content,
    handleContentChange,
    handleGenerateSummary,
    handleSaveSummary,
    isPending,
    showSaveButton,
  } = useSummary();

  return (
    <div className="w-full">
      <div className="bg-black mx-auto rounded-2xl p-6 px-10">
        <h1 className="text-white text-center text-2xl font-bold mb-3">
          Résumé de la leçon
        </h1>
        <div className="relative flex flex-col gap-4">
          {isPending ? (
            <div className="min-h-[200px] flex items-center justify-center">
              <AiLoader icon={summaryIcon} name="du résumé" />
            </div>
          ) : (
            <TextEditor
              value={content}
              backgroundColor="#000"
              onChange={handleContentChange}
            />
          )}
          <div className="flex justify-between gap-2 mb-2">
            <Button
              onClick={handleGenerateSummary}
              title="Générer le résumé"
              className="bg-white text-black"
              type="button"
              disabled={isPending}
            />
            {showSaveButton && content && (
              <Button
                onClick={handleSaveSummary}
                title="Enregistrer"
                type="button"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
